export default __webpack_public_path__ + "images/29cf875dd59e3301be675929e0ea67a8-3-01.svg";